/*
	Fullscreen product image viewer (shared singleton).

	Public API:
		window.openProductFullscreen(urls, startIndex)
		window.closeProductFullscreen()

	Per-product glue (urls + startIndex) lives in the
	`product-image-fullscreen.liquid` snippet.

	Safe to load once per page (guarded internally against double init).
*/
(function () {
	if (window.openProductFullscreen) return;

	var layer, slider, wrapper, swiper;
	var paginationEl, prevEl, nextEl;
	var PIXEL = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

	function ensureLayer() {
		if (layer) return;
		layer			= document.createElement('section');
		layer.className	= 'product-image-fullscreen is-hidden';
		layer.id		= 'product-fs-viewer';
		layer.tabIndex	= -1;
		layer.innerHTML	=
			'<span class="pr-fs-close">&times;</span>' +
			'<div id="product-fs-slider" class="swiper-container">' +
				'<div class="swiper-wrapper"></div>' +
				'<div class="pr-swiper-pagination pr-fs-pagination"></div>' +
				'<div class="swiper-button-prev pr-fs-prev"></div>' +
				'<div class="swiper-button-next pr-fs-next"></div>' +
			'</div>';
		document.body.appendChild(layer);
		slider			= layer.querySelector('#product-fs-slider');
		wrapper			= layer.querySelector('.swiper-wrapper');
		paginationEl	= layer.querySelector('.pr-fs-pagination');
		prevEl			= layer.querySelector('.pr-fs-prev');
		nextEl			= layer.querySelector('.pr-fs-next');

		layer.addEventListener('click', function (e) {
			if (e.target === layer || e.target === slider) close();
		});
		layer.querySelector('.pr-fs-close').addEventListener('click', close);
		prevEl.addEventListener('click', function (e) { e.stopPropagation(); });
		nextEl.addEventListener('click', function (e) { e.stopPropagation(); });
	}

	function close() {
		if (!layer || layer.classList.contains('is-hidden')) return;
		layer.classList.add('is-hidden');
		if (swiper) {
			try { swiper.destroy(true, true); } catch (e) {}
			swiper = null;
		}
		window.__productFsSwallowNextEsc = true;
	}

	function open(urls, idx) {
		if (!urls || !urls.length) return;
		ensureLayer();
		idx = idx || 0;

		var html = '';
		for (var i = 0; i < urls.length; i++) {
			html +=
				'<div class="swiper-slide">' +
					'<img src="' + PIXEL + '" data-src="' + urls[i] + '" class="swiper-lazy">' +
					'<div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>' +
				'</div>';
		}
		wrapper.innerHTML = html;
		layer.classList.remove('is-hidden');

		if (swiper) {
			try { swiper.destroy(true, true); } catch (e) {}
			swiper = null;
		}
		if (typeof Swiper === 'undefined') return;
		swiper = new Swiper(slider, {
			slidesPerView			: 1,
			slidesPerGroup			: 1,
			preloadImages			: false,
			lazy					: { loadPrevNext: true },
			initialSlide			: idx,
			observer				: true,
			observeParents			: true,
			observeSlideChildren	: true,
			keyboard				: { enabled: true },
			pagination				: {
				el					: paginationEl,
				clickable			: true
			},
			navigation				: {
				nextEl				: nextEl,
				prevEl				: prevEl
			}
		});

		var doFocus = function () {
			try { layer.focus({ preventScroll: true }); } catch (e) { try { layer.focus(); } catch (e2) {} }
			if (swiper && typeof swiper.update === 'function') swiper.update();
		};
		doFocus();
		requestAnimationFrame(doFocus);
		setTimeout(doFocus, 50);
	}

	window.openProductFullscreen	= open;
	window.closeProductFullscreen	= close;

	document.addEventListener('keydown', function (e) {
		if (e.key !== 'Escape') return;
		if (!layer || layer.classList.contains('is-hidden')) return;
		close();
		e.preventDefault();
		e.stopPropagation();
		e.stopImmediatePropagation();
	}, true);

	document.addEventListener('keyup', function (e) {
		if (e.key !== 'Escape') return;
		if (window.__productFsSwallowNextEsc) {
			window.__productFsSwallowNextEsc = false;
			e.stopPropagation();
			e.stopImmediatePropagation();
		}
	}, true);
})();
